import React, { useEffect, useRef, useState } from 'react';
import './registry.scss';

import { useDispatch, useSelector, useStore } from 'react-redux';
import { useForm } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { useSearchParams } from 'react-router';
import moment from 'moment';
import {
  calculatedViewMode,
  getFilterData,
  getPaginationOpts,
  getResponseError,
  responseLogWithNotification,
  useUpdatePeriod,
} from '../../../utils/utils';
import {
  loadCarrierById,
  loadCarrierList,
  loadCarrierFieldsValidation, extractCarrierById,
} from '../actions';
import { getSystemData } from '../../System/reducer';
import Loader from '../../../components/base/Loader/Loader';
import { getRegisterData } from '../reducer';
import CustomizedGrid from '../../../components/base/Grid/CustomizedGrid';
import Pagination from '../../../components/base/Pagination/Pagination';
import { Button, Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import FilterRow from '../../../components/base/FilterRow/FilterRow';
import FieldDTO from '../../../components/fields/Abstract/FieldDTO';
import TextInput from '../../../components/fields/TextInput/TextInput';
import ApplicationsDTO from '../../../dto/ApplicationsDTO';
import CustomSelectInput from '../../../components/fields/SelectInput/CustomSelectInput';
import CarrierView from './CarrierView';
import { errorNotification, successNotification } from '../../Notifications/notificationDecorator';
import {
  REGISTRIES_STATUS_LIST,
} from '../../../configs';
import TooltipWithPortal from '../../../components/base/Tooltip/TooltipWithPortal';
import RangeDatePicker from '../../../components/fields/RangeDatePicker/RangeDatePicker';
import { additionalCarrierColumns, carrierColumns } from './carrierColumns';
import getDefaultDataRange from '../../../utils/getDefaultDataRange';
import { REGION_REGISTRY_MODULE } from '../../../configs/moduleNames';
import getDefaultSort from '../../../utils/getDefaultSort';
import FilterModal from '../../FilterTemplate/components/FilterModal';
import { PAGE_TYPE } from '../../FilterTemplate/components/filter-settings';
import ViewDocument from '../../System/components/ViewDocument';
import ExportInterface from '../../System/components/ExportInterface';

export default function CarrierRegistryPage() {
  const blockRef = useRef(null);
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const store = useStore();
  const [isOpenFilter, setOpenFilter] = useState(false);
  const [showView, setShowView] = useState(false);
  const { updatePeriod } = useSelector(getSystemData);
  const [searchParams, setSearchParams] = useSearchParams();
  const registry_id = searchParams.get('registry_id');
  const numbersText = searchParams.get('numbers') || '';
  const [showExtract, setShowExtract] = useState(false);
  const numbers = numbersText.split(',') || [];
  const {
    loadingCarrierList,
    carrierList = [],
    carrierListMeta = {},
    currentCarrier = {},
    loadingCurrentCarrier = false,
    carrierFieldsValidation = {},
    loadingCarrierExtractList,
    carrierExtractList,
  } = useSelector(getRegisterData);

  const defaultDate = getDefaultDataRange();
  const defaultFilterValues = {
    // created_at_from: defaultDate[0],
    // created_at_to: defaultDate[1],
    view_mode: 2,
    numbers,
  };

  const filterName = 'carrier-filter';
  const {
    getValues, control, watch, setValue, reset,
  } = useForm({
    defaultValues: defaultFilterValues,
    resetOptions: {
      keepValues: false,
      keepDirtyValues: false,
      keepDefaultValues: false,
    },
  });

  const loadRegistry = () => {
    if (registry_id) {
      dispatch(loadCarrierById(registry_id))
        .then(() => {
          dispatch(loadCarrierFieldsValidation({ id: registry_id })).catch(responseLogWithNotification);
          setShowView(true);
        })
        .catch(response => errorNotification('Загрузка реестровых данных', getResponseError(response)));
    }
  };
  const loadData = opts => {
    const filterData = getValues();
    const viewModeData = calculatedViewMode(filterData.view_mode);
    delete filterData.view_mode;
    const paginationOpts = getPaginationOpts(store.getState()[REGION_REGISTRY_MODULE].carrierListMeta, opts); // костыль внедрен из за потери контекста в updatePeriod. Он сохранял первую функцию
    const requestData = {
      ...paginationOpts,
      filter: { ...filterData, ...viewModeData },
      sort,
    };
    const p1 = dispatch(loadCarrierList(requestData)).catch(responseLogWithNotification);
    return Promise.all([p1]);
  };

  const [sort, setSort] = useState(getDefaultSort(carrierColumns));

  const changeSort = fieldName => {
    if (sort && (sort === fieldName || sort === `-${fieldName}`)) {
      if (sort === `-${fieldName}`) {
        setSort(fieldName);
      } else if (sort === fieldName) {
        setSort('');
      }
    } else {
      setSort(`-${fieldName}`);
    }
  };

  useEffect(() => { loadData(); }, [sort]);

  const [setPeriod] = useUpdatePeriod(loadData, updatePeriod);
  useEffect(() => reset(getFilterData(filterName, defaultFilterValues)), []);
  useEffect(() => setPeriod(updatePeriod), [updatePeriod]);
  useEffect(loadRegistry, [registry_id]);
  useEffect(() => {
    const subscription = watch(values => {
      localStorage.setItem(filterName, JSON.stringify(values));
      loadData({ page: 1 });
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  const DTO = new ApplicationsDTO();
  const attributes = DTO.getAttributesByName();

  const handleExtract = item => event => {
    if (!item) {
      return;
    }

    dispatch(extractCarrierById({ id: item.id }))
      .then(() => {
        successNotification('Выписка', 'Выписка прошла успешно');
        setShowExtract(true);
      })
      .catch(response => errorNotification('Выписка', getResponseError(response)));
  };

  const handleShow = item => event => {
    if (!item) {
      return;
    }
    setSearchParams({ registry_id: item.id });
    event.preventDefault();
    event.stopPropagation();
  };

  const handleClose = item => {
    setSearchParams({});
    setShowExtract(false);
  };

  const moreFormatter = (_, item) => (
    <TooltipWithPortal
      content={<Icons customIcon icon="more-vert" className="more-vert" />}
      classNamePortal="more-actions"
      tooltipContent={(
        <div className="more-wrapper">
          <Button variant="link" className="w-100 more-button" onClick={handleShow(item)}>
            Просмотреть
          </Button>
          <Button variant="link" className="w-100 more-button" onClick={handleExtract(item)}>
            Выписка
          </Button>
        </div>
      )}
      classNameWrapper="more-tooltip-wrapper"
      className="more-tooltip"
    />
  );

  const rowClassFormatter = item => {
    const classes = ['clickable-table-row'];
    const ed = moment(item.expiration_date);
    const now = moment();
    if (ed.isValid() && now.diff(ed, 'days') >= 0) {
      classes.push('expiration');
    }
    if (item && item.archived_at) {
      classes.push('is_archive');
    }
    return classes.join(' ');
  };

  return (
    <div className="page application-page">
      <Loader
        global
        loading={loadingCarrierList || loadingCurrentCarrier || loadingCarrierExtractList}
      />
      <div className="page-title">
        <div className="title-text">{formatMessage({ id: 'menu.region.registry.carrier' })}</div>
        <FilterRow>
          <FieldDTO
            control={control}
            component={TextInput}
            dtoObject={{
              name: 'search',
              type: String,
              labelKey: 'search',
            }}
            className="no-border"
            inputBefore={(
              <div className="search-wrapper">
                <Icons customIcon className="search" width={24} height={24} icon="search" />
              </div>
            )}
          />
          <FieldDTO
            control={control}
            component={CustomSelectInput}
            dtoObject={attributes.status}
            usePortal
            className="no-border"
            options={REGISTRIES_STATUS_LIST}
            placeholder="Статус"
            addPlaceholder
          />
          {/* <FieldDTO */}
          {/*  control={control} */}
          {/*  component={RangeDatePicker} */}
          {/*  dtoObject={attributes.created_at} */}
          {/*  usePortal */}
          {/*  placeholder="Дата" */}
          {/*  changeFormat="YYYY-MM-DD" */}
          {/*  inputProps={{ */}
          {/*    value: [getValues('created_at_from'), getValues('created_at_to')], */}
          {/*    onChange: e => { */}
          {/*      const v = e.target.value; */}
          {/*      setValue('created_at_from', v[0]); */}
          {/*      setValue('created_at_to', v[1]); */}
          {/*    }, */}
          {/*  }} */}
          {/*  className="no-border" */}
          {/* /> */}
          <div className="filter-sep" />
          <ExportInterface page="carriers" exporter="carriers" getValues={getValues} />
          <div className="filter-sep" />
          <Button
            variant="second"
            className=""
            onClick={() => {
              setOpenFilter(true);
            }}
          ><Icons customIcon className="file-download" width={24} height={24} icon="filter" />
          </Button>
          {isOpenFilter
            ? (
              <FilterModal
                control={control}
                onClose={() => setOpenFilter(false)}
                getValues={getValues}
                reset={reset}
                defaultValues={defaultFilterValues}
                page={PAGE_TYPE.REGION_REGISTRY_CARRIER}
              />
            )
            : null}
        </FilterRow>
      </div>
      <div className="page-content-wrapper">
        <div className="page-content" ref={blockRef}>
          <div className="grid-wrapper frame">
            <div className="custom-scroll-theme sticky-table-wrapper">
              <CustomizedGrid
                onDoubleClickByRow={(item, event) => handleShow(item)(event)}
                rowClassFormatter={rowClassFormatter}
                data={carrierList}
                columns={carrierColumns}
                changeSort={changeSort}
                sort={sort}
                additionalColumns={additionalCarrierColumns}
                name="carrier-list"
                settingsFormatter={moreFormatter}
              />
            </div>
          </div>
          <Pagination meta={carrierListMeta} list={carrierList} handleChangeMeta={loadData} />
        </div>
      </div>
      {showView && currentCarrier ? <CarrierView formMeta={carrierFieldsValidation} onClose={() => { handleClose(); setShowView(false); }} loadData={loadData} /> : null}
      {showExtract && carrierExtractList
        ? (
          <ViewDocument
            loadData={loadData}
            loadingCarrierExtractList={loadingCarrierExtractList}
            handleClose={handleClose}
            document={{ files: [carrierExtractList] }}
            prevCrumbs={(
              <>
                <span className="breadcrumbs-prev">Реестры</span>
                <Icons width={22} height={22} customIcon icon="arrow-right" className="breadcrumbs-arrow" />
                <span className="breadcrumbs-prev">Реестр перевозчиков</span>
                <Icons width={22} height={22} customIcon icon="arrow-right" className="breadcrumbs-arrow" />
              </>
            )}
          />
        ) : null}
    </div>
  );
}
